package one.healthium.tutorial.domain

import one.healthium.base.preferences.AppPreferences
import one.healthium.featureconfig.domain.CoreFeatureConfigKeys
import one.healthium.featureconfig.domain.FeatureConfigInteractor

class TutorialInteractor(
    private val tutorialRepository: TutorialRepository,
    private val appPreferences: AppPreferences,
    private val featureConfigInteractor: FeatureConfigInteractor,
) {

    suspend fun getTutorial(): TutorialModel? {
        when {
            appPreferences.introTutorialShown.not() -> {
                return tutorialRepository.getIntro()
            }

            appPreferences.isMealPlanTutorialShown.not() && featureConfigInteractor.isEnabled(CoreFeatureConfigKeys.EnablePersonalMealPlan) -> {
                return TutorialModel.MealPlanTutorial
            }
        }

        return null
    }

    suspend fun setIntroTutorialShown() {
        appPreferences.introTutorialShown = true
        if (featureConfigInteractor.isEnabled(CoreFeatureConfigKeys.EnablePersonalMealPlan)) {
            // no need to show meal plan tutorial in this case since now by default assigned personal meal plan
            appPreferences.isMealPlanTutorialShown = true
        }
    }
}
